export default {
  setting: (state) => {
    return state.setting;
  },
  booths: (state) => {
    return state.booths;
  },
  boothOptions: (state) => {
    return (state.booths || []).map((item) => ({
      value: item.id,
      text: item.code ? item.code + " | " + item.title : item.title,
    }));
  },
  storeOptions: (state) => {
    return (state.storeOptions || []).map((item) => ({
      value: item.id,
      text: item.code ? item.code + " | " + item.title : item.title,
    }));
  },
  branchUserPersons: (state) => {
    return state.branchUserPersons;
  },
  branchUserOptions: (state) => {
    return (state.branchUserPersons || []).map((item) => ({
      value: item.userId,
      text: item.username ? item.title + " (" + item.username + ")" : item.title,
      personId: item.personId,
    }));
  },
  stores: (state) => {
    return state.stores;
  },
  boothList: (state) => {
    return state.boothList;
  },
  preOrders: (state) => {
    return state.preOrders;
  },
  preOrderById: (state) => {
    return state.preOrderById;
  },
  shopSaleFactors: (state) => {
    return state.shopSaleFactors;
  },
  userStores: (state) => {
    return state.userStores;
  },
  userStoreOptions: (state) => {
    return (state.userStores || []).map((item) => ({
      value: item.id,
      text: item.code ? item.code + " | " + item.title : item.title,
    }));
  },
  // گروه‌های پنل فروش به ترتیب اولویت
  salePanelGroups: (state) => {
    return [...(state.salePanelGroups || [])]
      .filter((item) => item.showInSalePanel !== false)
      .sort((a, b) => (a.priority ?? 1e9) - (b.priority ?? 1e9));
  },
  printLink: (state) => {
    return state.printLink;
  },
  orderSettlementTypes: (state) => {
    return state.orderSettlementTypes;
  },
  posTerminalOptions: (state) => {
    return (state.activePosTerminals || []).map((item) => ({
      value: item.id,
      text: item.code ? item.code + " | " + item.title : item.title,
    }));
  },
  benefitCardOptions: (state) => {
    return (state.activeBenefitCards || []).map((item) => ({
      value: item.id,
      text: [item.cardNumber, item.ownerPersonClubFullName]
        .filter(Boolean)
        .join(" | "),
      isPinRequired: !!item.isPinRequired,
      balance: item.balance,
    }));
  },
};
